  <template>
    <section class="cta">
      <div class="cta__content container">
        <div class="cta__info">
          <h2>
            Experience the Energy.
          </h2>
          <h1>
            Sequire Investor Summit 2027
          </h1>
          <hr class="half-line --full" />
          <div class="cta__buttons">
            <a href="https://forms.monday.com/forms/5ab96b8f289480d9d3479556bcc057e0?r=use1" target="_blank">
              <button class="btn-new">
                Conference Pass
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </a>
            <a href="https://buy.stripe.com/4gM8wOclm2yk27l2la3cc0V" target="_blank">
              <button class="btn-new-alt">
                Presenter Pass
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div class="cta__graph">
          <div class="blue-shape">
            <h3>Jan 19-21, 2027</h3>
            <h6>Condado Vanderbilt</h6>
            <h4>San Juan, Puerto Rico</h4>
          </div>
          <img src="../assets/graphics/full-shape.svg" alt="Isotype Full Shape">
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'cta',
    props: {
      message: {
        type: String,
        default: 'Get Your Company Pass'
      },
      alternativeStyling: {
        type: Boolean,
        required: false
      },
      biggerSize: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/cta.scss";
  </style>
  